export default {
  tableRow: 'dt.components.shared.table.tableRow',
  tableCell: 'dt.components.shared.table.tableCell',
};
